import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import loanFormModel from '../../../../../../../components/loan_application/form_models/loanFormModel';
import * as Yup from 'yup';
import { BusinessRuleBase } from '../../business/BusinessBase';
import { GenericValidation } from '../../../../../../../validations/GenericValidation';
const {
  formField: { principalType, principalFirstName },
} = loanFormModel;

export class PrincipalFirstNameValidation implements ValidationSchema {
  public name = principalFirstName.name;
  public label = principalFirstName.label;
  public dependsOn: string[] = [];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  public when(schema: Yup.StringSchema, context: any) {
    const bl = new BusinessRuleBase(context.parent);

    if (bl.isPrincipal() && !bl.isTrust())
      return schema.required(principalFirstName.requiredErrorMsg);

    return GenericValidation.create({
      nullable: true,
      required: false,
    });
  }
}
export default new Validation(new PrincipalFirstNameValidation());
